/**
 * Created by ssuo on 5/18/2015.
 */
'use strict';

var keyMirror = require('keymirror');
var myAccountURI = '/myaccount';
var bundleRequestURI = '/myaccount/bundle';
var ppacRequestURI = '/myaccount/bundle/cards/anywhere';
var cardsRequestURI = '/myaccount/bundle/cards';
var ucsRequestURI = '/myaccount/debitcards/manage';

module.exports = {
    ActionTypes: keyMirror({
        ADDRESS_LIST_DATA_FETCH_SUCCESS: null,
        ADDRESS_LIST_DATA_FETCH_FAIL: null,
        ADDRESS_ADD_SUCCESS: null,
        ADDRESS_ADD_FAIL: null,

        NORMALIZE_ADDRESS_SUCCESS: null,
        NORMALIZE_ADDRESS_FAIL: null
    }),

    AppConstants: {
        ACCOUNT_SUMMARY_URL: myAccountURI + '/summary',
        MANAGE_CARD_URL: cardsRequestURI + '/home',
        SET_PIN_URL: ucsRequestURI + '/:card_id/create-pin',
        UPDATE_PIN_URL: ppacRequestURI + '/update-pin/',
        REPORT_LOST_CARD_URL: ppacRequestURI + '/report-card-lost',
        SHOW_CARD_URL: ppacRequestURI + '/show-card/',
        REPLACE_DAMAGED_CARD_URL: ppacRequestURI + '/reissue/',
        CLOSE_CARD_URL: ppacRequestURI + '/close-card',
        REPLACE_CARD_URL: cardsRequestURI + '/:card_id/replace',
        RISK_REPLACE_CARD_URL: cardsRequestURI + '/:card_id/riskreplace',
        UPDATE_PREFERRED_PAYMENT_URL: ppacRequestURI + '/update-funding-source/',
        CHANGE_ADDRESS_URL: ppacRequestURI + '/update-address/',
        ACTIVATE_APPLY_URL: ppacRequestURI + '/activate',
        NOTIFICATION_SETTINGS_URL: cardsRequestURI + '/notification-settings',
        LOW_BALANCE_SETTINGS_URL: bundleRequestURI + '/settings/lowbalance',
        UPDATE_LOW_BALANCE_URL: bundleRequestURI + '/settings/low-balance-alert/',

        ADDRESS_ADD_URL: bundleRequestURI + '/add-address/',
        NORMALIZE_ADDRESS_URL: bundleRequestURI + '/normalize-address',
        UPGRADE_URL: bundleRequestURI + '/upgrade',
        ENROLL_URL: bundleRequestURI + '/enroll',
        SIGNUP_UPGRADE_URL: bundleRequestURI + '/signup/upgrade',
        SIGNUP_ENROLL_URL: bundleRequestURI + '/signup/enroll',
        LOG_ERROR_URL: bundleRequestURI + '/error',

        PRODUCT_ELIGIBILITY_URL: bundleRequestURI + '/product-eligibility',

        MANUAL_TOPUP_URL: bundleRequestURI + '/manual-topup',

        ENROLL_CARD_URL: bundleRequestURI + '/cards/enroll',

        API_REQUEST: {
            X_PP_CORRID_HEADER: 'x-pp-corrid'
        },

        APPLY_PRIMARY: {
            CARD_ELIGIBILITY_STATUSES: keyMirror({
                ELIGIBLE_WITH_CONDITIONS: null,
                ELIGIBLE: null,
                INELIGIBLE: null,
                NEED_MORE_INFO: null,
                NEED_MORE_DATA: null,
                APPROVED: null,
                DENIED: null,
                MANUAL_REVIEW: null,
                ERROR: null,
                SIMILAR_PRODUCT_EXISTS: null,
                INVALID_ACCOUNT_STATE: null
            }),
            CIP_FORM_FIELDS: keyMirror({ SSN9: null, DOB: null })
        },

        APPLY_CARD_STATUS: {
            APPROVED: 'APPROVED',
            NEED_MORE_DATA: 'NEED_MORE_DATA',
            MANUAL_REVIEW: 'MANUAL_REVIEW',
            STEPUP_AUTH: 'STEPUP_AUTH',
            DENIED: 'DENIED'
        },

        APPLY_CARD_ERROR_CODE: {
            NEED_MORE_INFO: 'NEED_MORE_INFO',
            CIP_FAILURE: 'CIP_FAILURE'
        },

        FLOW_NAME: {
            UPGRADE_BUNDLE: 'UPGRADE_BUNDLE',
            ACTIVATE_CARD: 'ACTIVATE_CARD',
            MANAGE_CARD: 'MANAGE_CARD',
            CHANGE_BILLING_ADDRESS: 'CHANGE_BILLING_ADDRESS',
            REPORT_LOST_CARD: 'REPORT_LOST_CARD',
            DAMAGED_CARD: 'DAMAGED_CARD',
            REPLACE_CARD: 'REPLACE_CARD',
            ENROLL_CARD: 'ENROLL_CARD'
        },

        CFPB_ACCOUNT_TYPE: {
            WALLET: 'CFPB_ACCOUNT_TYPE_WALLET',
            CASH_PLUS: 'CFPB_ACCOUNT_TYPE_CASH_PLUS',
            CASH: 'CFPB_ACCOUNT_TYPE_CASH'
        },

        MERCHANT: 'merchant',
        CONSUMER: 'consumer',
        ENROLL: 'ENROLL',
        UNENROLL: 'UNENROLL',
        PAYPAL_ANYWHERE_CARD_CARDHOLDER_AGREEMENT_LINK:
            'https://www.paypal.com/us/webapps/mpp/ua/consumer-anywherecard-agreement',
        ELECTRONIC_COMMUNICATION_DELIVERY_POLICY_LINK: 'https://www.paypal.com/us/webapps/mpp/ua/esign-full',
        BANCORP_BANK_PRIVACY_POLICY_LINK: 'http://www.thebancorp.com/privacy-policy/',
        PP_DEBIT_CARD_DISPUTE_RESOLUTION_PAGE_URL:
            'https://www.paypal.com/us/cgi-bin/webscr?cmd=_dc-claim&txn_id=',
        // User could choose not to set a BUF for a card, this constant is used for BUF id of this special case so our
        // program logic is consistent
        BUF_ID_OF_NO_BACKUP_FUNDING_SOURCE: -1,

        SUMMARY_PAGE_RELATIVE_URL: '/myaccount/bundle/summary',

        // Signup upgrade content key prefix
        KEY_PREFIX: {
            SIGNUP: 'signup_'
        },

        // normalize-address endpoint status
        // TODO: To standardize status code
        NORMALIZE_ADDRESS_STATUS: {
            NORMALIZE_VALID: 'valid',
            NORMALIZE_CORRECTED: 'corrected',
            NORMALIZE_INVALID: 'invalid',
            PO_BOX_UNSUPPORTED: 'PO_BOX_UNSUPPORTED',
            ADDRESS_REGION_NOT_SUPPORTED: 'ADDRESS_REGION_NOT_SUPPORTED',
            INVALID: 'INVALID'
        },
        NORMALIZE_ADDRESS_SCOPE: {
            MEDIUM: 'MEDIUM'
        },
        ADDRESS_STATUS: {
            VALID: 'VALID',
            INVALID: 'INVALID',
            CORRECTED: 'CORRECTED',
            PO_BOX_UNSUPPORTED: 'PO_BOX_UNSUPPORTED',
            ADDRESS_REGION_NOT_SUPPORTED: 'ADDRESS_REGION_NOT_SUPPORTED',
            // Validate Address - Error Response status is INVALID
            INVALID_INPUT: 'INVALID'
        },
        ADDRESS_STATUS_CONTENT_KEY: {
            PO_BOX_UNSUPPORTED: 'address_validation.invalid_po_box',
            US_TERRITORY_UNSUPPORTED: 'address_validation.invalid_territory_unsuppported',
            INVALID: 'address_validation.invalid_address'
        },
        ADDRESS_TYPE: {
            BILLING: 'BILLING',
            SHIPPING: 'SHIPPING'
        },
        INVALID_ADDRESS_REASON: {
            ADDRESS_PO_BOX_NOT_ALLOWED: 'ADDRESS_PO_BOX_NOT_ALLOWED',
            PO_BOX_UNSUPPORTED: 'PO_BOX_UNSUPPORTED'
        },
        PIN_STATUS: {
            UNSET: 'UNSET',
            SET: 'SET'
        },
        PIN_ORIGIN: {
            SYSTEM: 'SYSTEM',
            USER: 'USER'
        },
        CARD_STATUS: {
            ACTIVE: 'ACTIVE',
            PENDING_ACTIVE: 'PENDING_ACTIVE'
        },
        REPLACE_CARD_REASON: {
            // BNW flow reasons
            UNDELIVERABLE: 'UNDELIVERABLE',
            LOST_IN_TRANSIT: 'LOST_IN_TRANSIT',
            CANCELLED_BY_RISK: 'CANCELLED_BY_RISK',
            DAMANGED_UNDELIVERED: 'DAMANGED_UNDELIVERED',

            // UCS flow reasons
            LOST_OR_STOLEN: 'LOST_OR_STOLEN',
            GET_PHYSICAL_CARD: 'GET_PHYSICAL_CARD'
        },
        TRAFFIC_SOURCE: {
            PEPPERJAM: 'pepperjam'
        },
        CONSUMER_PRODUCTS: keyMirror({
            INVESTMENT: null,
            CHECK_DEPOSIT: null,
            CASH_OUT: null,
            PAYPAL_CASH: null
        }),
        DEXTER_LINKS: {
            INVESTMENT: '/policydashboard/process/compliance/fincen',
            CHECK_DEPOSIT: '/policydashboard/process/compliance/fincen',
            CASH_OUT: '/policydashboard/process/compliance/fincen',
            PAYPAL_CASH: '/policydashboard/process/compliance/debitcard',
            CIP: '/policydashboard/process/compliance/cip'
        },
        CAPABILITY: {
            EARLY_ACCESS_DIRECT_DEPOSIT: 'EARLY_ACCESS_DIRECT_DEPOSIT',
            DIRECT_DEPOSIT: 'DIRECT_DEPOSIT'
        },
        BANKS: {
            BANCORP: 'Bancorp',
            WELLS_FARGO: 'Wells Fargo'
        },
        DD_STATES: {
            NEW: 'new',
            ENROLLED: 'enrolled'
        },
        FLOW_TYPES: {
            WEB: 'Web',
            APP: 'App'
        },
        CARD_TYPE: {
            PP_CASH_CARD: 'cash card'
        },
        PRODUCT_NAMES: {
            CONSUMER_DEBIT_CARD: 'CONSUMER_DEBIT_CARD'
        },
        CARD_CAPABILITIES: {
            AUTO_RELOAD: 'AUTO_RELOAD'
        },
        CARD_FORM_FACTOR: {
            TOKEN: 'TOKEN'
        },
        CARD_OPERATIONS: {
            APPLICATIONS: 'APPLICATIONS',
            CREATE: 'CREATE',
            ACTIVATE: 'ACTIVATE',
            REISSUE: 'REISSUE',
            REPORT_CARD_LOST: 'REPORT_CARD_LOST',
            CLOSE: 'CLOSE',
            DEACTIVATE: 'DEACTIVATE',
            UPDATE_CARD_DETAILS: 'UPDATE_CARD_DETAILS',
            UPDATE_SHIPPING: 'UPDATE_SHIPPING',
            PINS: 'PINS',
            EVALUATE_FUNDING_OPTIONS: 'EVALUATE_FUNDING_OPTIONS',
            FUNDING_OPTIONS: 'FUNDING_OPTIONS',
            SET_FUNDING_OPTIONS: 'SET_FUNDING_OPTIONS',
            REMOVE_FUNDING_OPTIONS: 'REMOVE_FUNDING_OPTIONS',
            SHOW_PIN: 'SHOW_PIN',
            SHOW_CARD: 'SHOW_CARD',
            CASHBACK_ENROLLMENTS: 'CASHBACK_ENROLLMENTS',
            UPDATE_TRANSACTION_SETTINGS: 'UPDATE_TRANSACTION_SETTINGS'
        },
        CARD_SUB_OPERATIONS: {
            REISSUED: 'REISSUED',
            SET_PIN: 'SET_PIN',
            CHANGE_BILLING_ADDRESS: 'CHANGE_BILLING_ADDRESS',
            REPLACE: 'REPLACE',
            REPORT_DIGITAL_CARD_LOST: 'REPORT_DIGITAL_CARD_LOST',
            CONVERT_FORM_FACTOR: 'CONVERT_FORM_FACTOR',
            WORN: 'WORN',
            CLOSE: 'CLOSE'
        },
        CARD_SHIPMENT_STATUS: {
            NOT_SHIPPED: 'NOT_SHIPPED',
            ON_THE_WAY: 'ON_THE_WAY',
            ARRIVED: 'ARRIVED'
        },
        CARD_LIFECYCLE_STATES: {
            ACTIVE: 'ACTIVE',
            CLOSED: 'CLOSED',
            PENDING_ACTIVE: 'PENDING_ACTIVE',
            DEACTIVATED: 'DEACTIVATED',
            REISSUED: 'REISSUED'
        },
        SHOW_CARD: {
            EVENT_NAMES: {
                UCS_DETAIL_CARD_MODULE_SHOWN: 'ucs_detail_card_module_shown',
                UCS_DETAIL_CARD_INSTANT_ACCESS_PRESSED: 'ucs_detail_card_instant_access_pressed',
                UCS_COPY_CARD_NUMBER_COPIED_SHOWN: 'ucs_copy_card_number_copied_shown',
                UCS_COPY_CARD_NUMBER_COPY_PRESSED: 'ucs_copy_card_number_copy_pressed',
                UCS_COPY_CARD_NUMBER_SCREEN_SHOWN: 'ucs_copy_card_number_screen_shown',
                UCS_COPY_CARD_NUMBER_FAIL_SCREEN_SHOWN: 'ucs_copy_card_number_fail_screen_shown',
                UCS_SHOW_CARD_SET_PIN_SUCCESS_MESSAGE_SHOWN: 'ucs_show_card_set_pin_success_message_shown',
                UCS_SHOW_CARD_SET_PIN_SUCCESS_MESSAGE_HIDDEN: 'ucs_show_card_set_pin_success_message_hidden'
            }
        },
        MANAGE_CARD: {
            EVENT_NAMES: {
                UCS_DETAIL_SCREEN_SHOWN: 'ucs_detail_screen_shown',
                UCS_DETAIL_MANAGE_SCREEN_SHOWN: 'ucs_detail_manage_screen_shown',
                UCS_MANAGE_CARD_ENROLLMENT_SUCCESS_MESSAGE_SHOWN:
                    'ucs_manage_card_enrollment_success_message_shown',
                UCS_MANAGE_CARD_ENROLLMENT_SUCCESS_MESSAGE_HIDDEN:
                    'ucs_manage_card_enrollment_success_message_hidden'
            }
        }
    }
};



/** WEBPACK FOOTER **
 ** ./public/js/constants.js
 **/